import { SubscriptionType } from '../server/mpsklad_core/Entity/Enums/SubscriptionType'

export const subscriptionTypeNames: {
  readonly [K in SubscriptionType]: string
} = {
  [SubscriptionType.None]: 'Нет',
  [SubscriptionType.Trial]: 'Пробный',
  [SubscriptionType.Monthly]: 'Месяц',
  [SubscriptionType.Yearly]: 'Год'
}